<div class="boxContainer">
  <div class="row boxContainer_titulo">
    <div class="col-8">
      <h2>Agenda</h2>
    </div>
    <div class="col-4 titulo_calendario">
      <a [routerLink]="['/calendario']" class="calendario-link bold">
        Ver calendário completo
      </a>
    </div>
  </div>
  <ul class="configuracoesList">
    <ng-container *ngFor="let card of iconCard">
      <li class="configuracoesList_item" (click)="selecionarPeriodo(card)">
        <img [src]="card.icon" class="configuracoesList_item_icon" />
        {{ card.name }} <br />
      </li>
    </ng-container>
  </ul>

  <div class="news-carousel mt-2" *ngIf="showCarousel">

    <ng-container *ngIf="paginatedItems.length === 1">
      <div class="single-event-card">
        <div class="product-item">
           <div class="product-item-content-card">
            <div style="padding: 4px !important;">
              <span *ngIf="paginatedItems[0].dscHoraInicioEvento" style="font-weight:500; font-size: 12px;">
                {{ paginatedItems[0].dscHoraInicioEvento }}
              </span>
              <span *ngIf="!paginatedItems[0].dscHoraInicioEvento" style="font-weight:500; font-size: 12px;">
                Horário não informado.
              </span>
            </div>
            <div class="p-mb-3 mt-2">
              <img *ngIf="paginatedItems[0].binPublicacao" [src]="paginatedItems[0].binPublicacao" class="imagem-card-carosel" />
              <div *ngIf="!paginatedItems[0].binPublicacao" class="no-image-card">
                <img src="/assets/svg/calendario.svg">
              </div>
              <div *ngIf="paginatedItems[0].nomePublicacao" style="padding: 5px !important;">
                <span class="p-mb-1" style="font-weight:600; font-size: 14px;">
                  {{ paginatedItems[0].nomePublicacao }}
                </span>
              </div>
              <div *ngIf="!paginatedItems[0].nomePublicacao" style="padding: 4px !important;">
                <span class="p-mb-1" style="font-weight:600; font-size: 14px;">
                  Nome do evento não informado.
                </span>
              </div>
              <div *ngIf="paginatedItems[0].dscEnderecoEvento" class="p-mb-1 mt-3" style="font-weight:600; font-size: 12px;">
                <img src="/assets/svg/marcador.svg" style="filter: grayscale(100%);" height="10px" width="10px">
                {{ paginatedItems[0].dscEnderecoEvento }}
              </div>
              <div *ngIf="!paginatedItems[0].dscEnderecoEvento" class="p-mb-1 mt-3" style="font-weight:600; font-size: 12px;">
                <span>Endereço não informado.</span>
              </div>
            </div>
          </div> 
        </div>
      </div>
    </ng-container> 
  
    <ng-container *ngIf="paginatedItems.length > 1">
        <p-carousel
          [value]="paginatedItems"
          styleClass="custom-carousel"
          [numVisible]="4"
          [numScroll]="1"
          [circular]="true"
          [responsiveOptions]="responsiveOptions"
          [autoplayInterval]="3000">
          <ng-template pTemplate="item" let-item>
            <div class="product-item">
              <div class="product-item-content">
                <div style="padding: 4px !important;">
                  <span *ngIf="item.dscHoraInicioEvento" style="font-weight:500; font-size: 12px;">
                    {{ item.dscHoraInicioEvento }}
                  </span>
                  <span *ngIf="!item.dscHoraInicioEvento" style="font-weight:500; font-size: 12px;">
                    Horário não informado.
                  </span>
                </div>
                <div class="p-mb-3 mt-2">
                  <img *ngIf="item.binPublicacao" [src]="item.binPublicacao" class="news-item_image" />
                  <div *ngIf="!item.binPublicacao" class="no-image">
                    <img src="/assets/svg/calendario.svg">
                  </div>
                  <div *ngIf="item.nomePublicacao" style="padding: 5px !important;">
                    <span class="p-mb-1" style="font-weight:600; font-size: 14px;">
                      {{ item.nomePublicacao }}
                    </span>
                  </div>
                  <div *ngIf="!item.nomePublicacao" style="padding: 4px !important;">
                    <span class="p-mb-1" style="font-weight:600; font-size: 14px;">
                      Nome do evento não informado.
                    </span>
                  </div>
                  <div *ngIf="item.dscEnderecoEvento" class="p-mb-1 mt-3" style="font-weight:600; font-size: 12px;">
                    <img src="/assets/svg/marcador.svg" style="filter: grayscale(100%);" height="10px" width="10px">
                    {{ item.dscEnderecoEvento }}
                  </div>
                  <div *ngIf="!item.dscEnderecoEvento" class="p-mb-1 mt-3" style="font-weight:600; font-size: 12px;">
                    <span>Endereço não informado.</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-carousel>
    </ng-container>

    <ng-container *ngIf="paginatedItems.length === 0">
      <div class="no-event-message mt-5">
        <p style="font-weight:600; font-size: 14px;">
          Nenhum evento encontrado para o período selecionado.
        </p>
      </div>
    </ng-container>

  </div>
  
</div>
